import { type GetEligibleCampaignsResponseType } from "@jti/rest-api-types";

export enum LOYALTY_CHOICE {
  COLLECT = 0,
  REDEEM = 1,
}

export type Loyalty = {
  points: number;
  pending_points: number;
  status: boolean;
  loyaltyChoice: LOYALTY_CHOICE | undefined;
  loyaltyCampaignId: string;
  isLoyaltyError: boolean;
  vouchers: GetEligibleCampaignsResponseType[];
  isLoaded: boolean;
  campaignErrors: {
    message: string;
  }[];
};
